export function Tape() {
  return <span className="tape" aria-hidden="true" />;
}
